import { REDUX_ACTIONS } from '../../shared/config/constants';
import { enqueueSnackbar } from './snackbar';
import { parseError } from '../../utils/fetchErrorParser';
import fetchAPI from '../../api/fetch';
import store from '../store';
import { modifyMetricData } from '../../utils/getMetrics';

export const fetchFeaturedWellDetails = () => (dispatch) => {
  const { hydraulicsLanding } = store.getState();
  const runType = hydraulicsLanding.runType;
  return fetchAPI
    .post('hydraulics/landing/wellInputs/fetch')
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      const featuredWell = data.data[runType];
      const drillFluids = data.data?.drillFluids || [];
      const formattedDrillFluids = drillFluids.map((fluid) => {
        const detail = fluid.details?.[0] || {};
        return {
          name: fluid.name,
          MD: fluid.MD,
          fluid_id: fluid._id,
          id: fluid._id,
          ...detail
        };
      });
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_LANDING_SET_FEATURED_WELL_RUN_TYPE_DATA,
        payload: featuredWell
      });

      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_LANDING_FEATURED_WELL_RUN_SUCCESS,
        payload: {
          data: {
            ...data.data,
            drillFluids: formattedDrillFluids
          },
          units: data.units,
        }
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
    });
};

export const runFeaturedWellHydraulics = (body) => (dispatch) => {
  const { hydraulicsLanding } = store.getState();
  const observationPoints = hydraulicsLanding.data?.observation_points;
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_LANDING_RUN_LOADING,
    payload: true
  });
  const { runId, data } = body;
  const input = {
    input: {
      url: `/runs/landing/${runId}`,
      method: 'POST',
      data: { ...data, observation_points: observationPoints }
    }
  };
  return fetchAPI
    .post('premiumHydraulics/noAuth/proxy', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_LANDING_SET_FEATURED_WELL_RUN_TYPE_DATA,
        payload: {
          results: data?.data?.detail?.result,
          run_details: body?.data?.run_details,
          inputs: body?.data?.inputs,
          runId
        }
      });
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_LANDING_RUN_LOADING,
        payload: false
      });
      dispatch(
        enqueueSnackbar(
          'Hydraulics Simulation Completed Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_LANDING_RUN_LOADING,
        payload: false
      });
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
    });
};

export const calculateFeaturedWellboreVolume = (body, setVolumeData, setLoading) => async (dispatch) => {
  const { fromMD, toMD, runId } = body;

  try {
    const input = {
      input: {
        url: `/runs/volumes/${runId}`,
        method: 'POST',
        data: { from: fromMD, to: toMD },
      },
    };
    const result = await fetchAPI.post('premiumHydraulics/noAuth/proxy', input);
    if (!result.ok) throw result;
    const data = await result.json();
    const { currentUser } = store.getState();
    const currentUnit = currentUser?.preferences?.unitSystem;
    const { results, units } = data.data.detail;
    setLoading(false);
    dispatch(
      enqueueSnackbar(
        'Wellbore Volume Calculated Successfully.',
        'success',
        Date.now() + Math.random()
      )
    );
    const updatedUnits = { ...units };

    if (results?.depths && results?.volumes) {
      updatedUnits.depths = Object.fromEntries(
        Object.keys(results.depths).map((key) => [key, { ...units.depths }])
      );
      updatedUnits.volumes = Object.fromEntries(
        Object.keys(results.volumes).map((key) => [key, { ...units.volumes }])
      );
      results.depths = modifyMetricData([results.depths], updatedUnits.depths, currentUnit)[0];
      results.volumes = modifyMetricData([results.volumes], updatedUnits.volumes, currentUnit)[0];
    } else {
      updatedUnits.volumes = Object.fromEntries(
        Object.keys(results).map((key) => [key, { ...units.volumes }])
      );
      results.volumes = modifyMetricData([results], updatedUnits.volumes, currentUnit)[0];
    }
    data.data.detail.units = updatedUnits;
    setVolumeData(data);
  } catch (error) {
    const errorMessage = await parseError(error);
    dispatch(
      enqueueSnackbar(
        errorMessage,
        'error',
        Date.now() + Math.random()
      )
    );
    setLoading(false);
    setVolumeData({});
  }
};

export const saveObservationPoints = (updatedObservationPoints) => (dispatch) => {
  const { hydraulicsLanding } = store.getState();
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_LANDING_FEATURED_WELL_RUN_SUCCESS,
    payload: {
      data: {
        ...hydraulicsLanding.data,
        observation_points: updatedObservationPoints
      },
      units: hydraulicsLanding.units,
    }
  });
};
